// İSG Portal — Select primitifi (yerel `<select>` + token'lı stil). Erişilebilir:
// yerel klavye/odak davranışı, hata durumu `aria-invalid`. Kanonik seçim shape'i
// `{ value, label }[]` — çağıran ekran, alan listesini (ör. şubeler) bu şekle map'ler
// ([[feedback_bibulut_selectlist_canonical_shape]]). Görsel dil Input ile eşleşir.

import { ChevronDown } from 'lucide-react';
import { forwardRef } from 'react';
import type { SelectHTMLAttributes } from 'react';
import { cn } from './cn';

/** Kanonik seçenek — `value` gönderilen kimlik, `label` görünen metin. */
export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
  options: SelectOption[];
  /** İlk (değersiz) seçenek metni — verilirse seçim zorunluluğunu işaret eder. */
  placeholder?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, invalid, options, placeholder, ...props },
  ref,
) {
  return (
    <div className="relative">
      <select
        ref={ref}
        aria-invalid={invalid || undefined}
        className={cn(
          'h-10 w-full appearance-none rounded-md border bg-surface px-3 pr-9 text-sm text-fg',
          'transition-colors',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:border-primary',
          'disabled:cursor-not-allowed disabled:opacity-60',
          // carbon: Input.tsx'i AYNALAR — alt-çizgi kontrol (yerel `<select>` bu dilimde
          // KALIYOR, `SelectMenu` Radix-tabanlı ayrı export — bkz. SelectMenu.tsx).
          'carbon:rounded-none carbon:border-0 carbon:border-b carbon:pl-4 carbon:focus-visible:ring-inset',
          // `Input.tsx`'in dosya başlığı notunu AYNALAR (S33 Slice 6 global düzeltme #2).
          'carbon:[[data-tile]_&]:bg-field',
          invalid
            ? 'border-danger focus-visible:ring-danger carbon:border-b-danger'
            : 'border-border-strong carbon:border-b-border-strong',
          className,
        )}
        {...props}
      >
        {placeholder ? <option value="">{placeholder}</option> : null}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <ChevronDown
        className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted"
        aria-hidden="true"
      />
    </div>
  );
});
